import { Link } from "react-router-dom";
import { TrendingUp, TrendingDown, Sparkles, Activity } from "lucide-react";

const Tile = ({ icon: Icon, tone, label, value, sub, to, testId }) => {
  const body = (
    <div className={`rounded-xl border p-4 h-full transition-colors ${tone} ${to ? "hover:bg-white/[0.04]" : ""}`} data-testid={testId}>
      <div className="flex items-center gap-2 text-[10px] font-mono font-bold uppercase tracking-[0.18em] text-white/50">
        <Icon className="w-3.5 h-3.5" /> {label}
      </div>
      <p className="text-3xl font-black text-white tabular-nums mt-1 leading-none">{value}</p>
      {sub && <p className="text-xs text-white/55 mt-2 leading-snug line-clamp-2">{sub}</p>}
    </div>
  );
  return to ? <Link to={to} className="block h-full">{body}</Link> : body;
};

const pulseText = (p) => {
  if (!p || !p.tracked) return "No forecast history yet";
  const moved = p.up + p.down;
  if (!moved) return `None of ${p.tracked.toLocaleString()} tracked forecasts changed in the last 30 days`;
  const net = p.netPP > 0 ? `+${p.netPP}` : `${p.netPP}`;
  return `of ${p.tracked.toLocaleString()} tracked forecasts changed in 30 days (${p.up} up, ${p.down} down), net ${net} pp`;
};

export const SignalsOverview = ({ overview }) => {
  if (!overview) return null;
  const up = overview.biggestUp;
  const down = overview.biggestDown;
  const pulse = overview.pulse?.["30"];
  const moved = pulse ? pulse.up + pulse.down : 0;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="signals-overview">
      <Tile icon={TrendingUp} tone="border-emerald-500/30 bg-emerald-500/[0.06]" label="Surges" value={overview.surges}
        sub={up ? `Biggest: ${up.billNumber} +${up.deltaPP} pp to ${Math.round(up.currentProbability * 100)}%` : "No bill has gained 5+ points"}
        to={up ? `/bill/${up.billId}` : undefined} testId="signals-tile-surges" />
      <Tile icon={TrendingDown} tone="border-rose-500/30 bg-rose-500/[0.06]" label="Drops" value={overview.drops}
        sub={down ? `Biggest: ${down.billNumber} ${down.deltaPP} pp to ${Math.round(down.currentProbability * 100)}%` : "No bill has lost 5+ points"}
        to={down ? `/bill/${down.billId}` : undefined} testId="signals-tile-drops" />
      <Tile icon={Sparkles} tone="border-purple-500/30 bg-purple-500/[0.06]" label="Stalled" value={overview.stalled}
        sub="Bills with no recorded action in 90+ days and a live forecast" testId="signals-tile-stalled" />
      <Tile icon={Activity} tone="border-orange-500/30 bg-orange-500/[0.06]" label="Floor pulse, 30 days"
        value={pulse ? (moved ? `${moved} moved` : "Steady") : "n/a"}
        sub={pulseText(pulse)} testId="signals-tile-pulse" />
    </div>
  );
};
